module.exports = __webpack_public_path__ + "static/media/tile-santa.4349c471.jpg";